import './assets/scss/App.scss'
import '@mdi/font/css/materialdesignicons.css'

import { Suspense, useEffect, useState } from 'react'
import { RouterProvider, createBrowserRouter, redirect } from 'react-router-dom'
import { LoadingModal, MainLayout, MessageBox } from '@/components'
import useLayoutStore from '@/store/layout'
import { routes } from './pages/router'
import { useAxiosGet } from './hooks'
import useStore from './store'
import { Session } from './store/types'
import { axios } from './util'

declare global {
    interface Window {
        kakao: any;
    }
}

function App ( props ) {
    const {
        accessToken: token,
        isLogin,
        setAccessToken,
        setIsLogin,
        setSession
    } = useStore()
    const { accessToken = token } = props
    const [ config ] = useState( { token: accessToken } )

    useEffect( () => {
        config.token = isLogin ? token : ''
    }, [ accessToken, token, isLogin ] )

    const getBrowserRouter = ( routers ) => {
        const lazyRouters = routers.map( ( { path, dynamicPath, accessLevel } ) => {
            const lazy = async () => {
                const module = await import( `@/pages/${ path }` )

                return {
                    Component: module.default,
                    loader: async () => {
                        if ( accessLevel === 'public' ) return null

                        try {
                            await axios.get( `/api/v1/admin/session`, {
                                headers: { 'Authorization': `Bearer ${ config?.token }` }
                            } )
                        } catch ( { status } ) {
                            return status === 401 ? redirect( `/login` ) : null
                        }

                        return null
                    },
                }
            }

            return { path: dynamicPath || path, lazy }
        } )

        lazyRouters.unshift( {
            path: '/',
            lazy: async () => {
                const module = await import( `@/pages/home` )

                return {
                    Component: module.default
                }
            }
        } )

        return createBrowserRouter( lazyRouters )
    }
    const axiosGet = useAxiosGet()
    const [ router ] = useState( getBrowserRouter( routes ) )
    const { setIsMobile } = useLayoutStore()

    const loader = () => <div>Loading...</div>
    const mainLoader = () => {
        return <MainLayout>{ loader() }</MainLayout>
    }
    const isMobile = (): boolean => {
        const { userAgent } = navigator
        const isMobile = userAgent.indexOf( 'iPhone' ) > -1 || userAgent.indexOf( 'Android' ) > -1

        return isMobile
    }

    useEffect( () => {
        setIsMobile( isMobile() )

        if( accessToken ) {
            setIsLogin( true )
            setAccessToken( accessToken )
            axiosGet<Session>( '/api/v1/admin/session', {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            } ).then( ( { data: session } ) => {
                setSession( session )
            } )
        }
    }, [] )

    return (
        <>
            <Suspense fallback={ mainLoader() }>
                <div className="prop-app flex flex-column">
                    <RouterProvider router={ router }/>
                </div>
                <div className="modal">
                    <MessageBox/>
                    <LoadingModal/>
                </div>
            </Suspense>
        </>
    )
}

export default App
